import validConst from '../../../assets/js/validate';
import JiuLawUpload from '@com.thunisoft.9law/uploadSDK';
import Vue from 'vue';
import * as api from '../../../assets/js/api';

/**
 * 材料上传核心功能类(不涉及任何UI处理，只处理上传、上传前文件整理逻辑)
 */
const MAX_SIZE = 50; // MB

class MaterialUpload {
  constructor() {
    this.uploadFileList = [];// 所有上传文件的统一管理array
    this.uploadMax = 500;// 最多支持500
    this.allFile = [];
    this.jiuLawUpload = null;
    // TODO 待完成-1。allFile统计错误信息和全部文件信息，读取上限限制
  }

  init() {
    this.uploadFileList = [];// 所有上传文件的统一管理array
  }

  cancel() {
    if (this.jiuLawUpload) {
      this.jiuLawUpload.abort();
    }
  }

  /**
   * 单案文件或者文件夹上传逻辑(拖拽)
   */
  dropUploadFileOrDirTask(dataTransfer, error, success) {
    if (dataTransfer.files.length > 0) {
      if (dataTransfer.files.length > 500) {
        msgErrorBack('单个案件最多支持500个文件或文件夹', error);
        return;
      }
      let filterDataTransferItems = [];
      this.uploadFileList = [];
      // 先过滤一次
      console.log('dataTransfer.files', typeof dataTransfer.files, dataTransfer);

      Object.keys(dataTransfer.files).forEach(key => {
        const file = dataTransfer.files[key];
        if (file.type != '') {// 文件
          this.uploadFileList.push(file);
        }
      });
      const that = this;
      filterDataTransferItems = dataTransfer.items;
      console.log('filterDataTransferItems', filterDataTransferItems, this.uploadFileList);
      let readDataIdx = 0;
      if (filterDataTransferItems.length > 0) {
        callBackFunc();
      } else {
        success ? success(this.uploadFileList) : '';
      }

      function callBackFunc() {
        if (readDataIdx <= filterDataTransferItems.length - 1) {
          console.log('this.uploadFileList-next', readDataIdx);
          that.readDataTransfer(filterDataTransferItems, readDataIdx, () => {
            readDataIdx++;
            callBackFunc();
          });
        } else {
          console.log('this.uploadFileList-end', that.uploadFileList, that.allFile);
          success ? success(that.uploadFileList) : '';
        }
      }
    } else {
      msgErrorBack('请选择文件或者文件夹', error);
    }
  }

  readDataTransfer(dataTransferItems, readIdx, callBack) {
    const dataTransferItem = dataTransferItems[readIdx];
    if (dataTransferItem.type == '') {
      // 读取文件夹中的文件
      const that = this;
      let dirReadIndex = 1;
      const childDirData = [];
      const dirData = dataTransferItem.webkitGetAsEntry();

      // 先处理有多少个dir
      readDirEntries(dirData, (entryList) => {
        entryList.forEach(entry => {
          if (entry.isFile) {
            that.updateUploadFile(entry, () => {
              if (dirReadIndex == entryList.length) {
                console.log('childDirData', childDirData);
                that.readChildDirData(childDirData, callBack);
              } else {
                dirReadIndex++;
              }
            });
          } else {// 目录
            childDirData.push(entry);
            if (dirReadIndex == entryList.length) {
              console.log('childDirData', childDirData);
              that.readChildDirData(childDirData, callBack);
            } else {
              dirReadIndex++;
            }
          }
        });
      }, () => {
        console.log('dirReadIndex-失败', dirReadIndex);
        // 最终结果返回
        callBack ? callBack() : '';
      });
    } else {
      console.log('updateUploadFile', dataTransferItem, typeof dataTransferItem);
      this.updateUploadFile(dataTransferItem, callBack);
    }
  }


  readChildDirData(childDirData, callBack) {
    const thirdDirData = [];
    const that = this;
    let index = 1;
    // 读取子目录
    if (childDirData && childDirData.length > 0) {
      childDirData.forEach(childDirItem => {
        let childDirReadIndex = 1;
        readDirEntries(childDirItem, (entryList) => {
          entryList.forEach(entry => {
            if (entry.isFile) {
              that.updateUploadFile(entry, () => {
                console.log('childDirReadIndex--', childDirReadIndex, entry);
                if (childDirReadIndex == entryList.length) {
                  if (index == childDirData.length) {
                    console.log('index--', index, entryList.length, entryList, this.uploadFileList);
                    // 最终结果返回
                    this.readThirdDirData(thirdDirData, callBack);
                  } else {
                    index++;
                  }
                } else {
                  childDirReadIndex++;
                }
              });
            } else {
              thirdDirData.push(entry);
              // 目前需要支持读取这种目录格式下的所有文件  目录1／目录2／目录3
              if (childDirReadIndex == entryList.length) {
                if (index == childDirData.length) {
                  this.readThirdDirData(thirdDirData, callBack);
                } else {
                  index++;
                }
              } else {
                childDirReadIndex++;
              }
            }
          });
        }, () => {
          console.log('index-失败', index);
          if (index == childDirData.length) {
            // 最终结果返回
            callBack ? callBack() : '';
          } else {
            index++;
          }
        });
      });
    } else {
      // 最终结果返回
      callBack ? callBack() : '';
    }
  }


  readThirdDirData(thirdDirData, callBack) {
    const that = this;
    let index = 1;
    // 读取子目录
    if (thirdDirData && thirdDirData.length > 0) {
      thirdDirData.forEach(thirdDirItem => {
        let thirdDirReadIdx = 1;
        readDirEntries(thirdDirItem, (entryList) => {
          entryList.forEach(entry => {
            if (entry.isFile) {
              that.updateUploadFile(entry, () => {
                if (thirdDirReadIdx == entryList.length) {
                  console.log('thirdDirReadIndex--', thirdDirReadIdx, entry);
                  if (index == thirdDirData.length) {
                    callBack ? callBack() : '';
                  } else {
                    index++;
                  }
                } else {
                  thirdDirReadIdx++;
                }
              });
            } else if (thirdDirReadIdx == entryList.length) {
              if (index == thirdDirData.length) {
                callBack ? callBack() : '';
              } else {
                index++;
              }
            } else {
              thirdDirReadIdx++;
            }
          });
        }, () => {
          console.log('index-失败', index);
          if (index == thirdDirData.length) {
            // 最终结果返回
            callBack ? callBack() : '';
          } else {
            index++;
          }
        });
      });
    } else {
      // 最终结果返回
      callBack ? callBack() : '';
    }
  }

  // 直接读取文件/读取dataItem的fileEntry判断是否可以加入上传队列
  updateUploadFile(dataTransferItemFile, callBack) {
    // 这里需要注意处理file对象还是fileSystem对象
    if (dataTransferItemFile.kind != 'file') {
      readFile(dataTransferItemFile, (file) => {
        this.allFile.push(file);
        // 检查是否符合文件上传规则（大小、后缀）
        checkFileEntryStandard(file, () => {
          this.uploadFileList.push(file);
          if (callBack) {
            callBack();
          }
        }, () => {
          if (callBack) {
            callBack();
          }
        });
        // console.log('file', file)
      }, () => {
        if (callBack) {
          callBack();
        }
      });
    } else if (callBack) {
      callBack();
    }
  }

  checkZipStandard(fileEntry, success, fail) {
    checkFileEntryStandard(fileEntry, success, fail, true, 10 * 1024);
  }

  checkFileStandard(fileEntry, success, fail) {
    checkFileEntryStandard(fileEntry, success, fail, false, 50);
  }

  /**
   *
   * @param files {[file]}
   * @param progress
   * @param complete
   * @param fail
   * @param useCheck
   */
  uploadFiles(files, progress, complete, fail, useCheck = false) {
    if (files && files.length > 0) {
      if (!this.jiuLawUpload) {
        this.jiuLawUpload = new JiuLawUpload({
          baseUrl: `${api.BASE_SERVER}`,
          preUrl_: '/api/v1/file/generatePresignedInfo',
          verifyFileUrl: '/api/v1/file/verifyFile',
          classType:'brtTest',
        });
      }
      console.log('调用uploadFiles');
      let uploadErrList = [],
        uploadSuccessList = [];

      // 如果是单个文件，展示单个文件的上传进度即可
      const isSingleFile = files.length == 1;

      function uploadCallBack(res) {
        if (res.data && (res.code == 200 || res.status == 200)) {
          const successTip = `${res.data.file.name}：上传成功`;
          const result = {
            tip: successTip,
            fileName: res.data.file.name,
            saveId: res.data.fileId,
            absolutePath: res.data.file.webkitRelativePath ? res.data.file.webkitRelativePath : '',
            fileSize: res.data.file.size,
          };
          uploadSuccessList.push(result);
        } else if (res.data && res.data.file && res.data.file.name) {
          // 上传失败
          const errTip = `【${res.data.file.name}】${res.msg},`;
          // let result = {
          //   tip: errTip,
          //   fileName: res.data.file.name,
          //   saveId: res.data.fileId,
          //   absolutePath: res.data.file.webkitRelativePath ? res.data.file.webkitRelativePath : '',
          //   filesize: res.data.file.size,
          // }
          uploadErrList.push(errTip);
        }
        // 检查是否全部完成上传操作
        if (uploadSuccessList.length + uploadErrList.length == files.length) {
          complete ? complete(uploadSuccessList, uploadErrList, '上传完成') : '';
        } else if (isSingleFile) {
          progress ? progress(100) : '';
        } else {
          let progressValue = (uploadSuccessList.length + uploadErrList.length) / files.length;
          progressValue = progressValue ? progressValue * 100 : 0;
          console.log('上传进度:---', progressValue, uploadSuccessList.length, uploadErrList.length, files.length);
          progress ? progress(progressValue) : '';
        }
      }

      // TODO 待补全埋点参数
      // let fid = Vue.prototype.$reportJs.eventLog('3_1')
      console.log('uploadFiles', files);
      if (files.length > 0) {// 优化进度展示
        progress ? progress(0) : '';
      }
      files.forEach(file => {
        if (useCheck) {
          this.checkFileStandard(file, (fileEntry) => {
            this.upload(fileEntry, uploadCallBack, () => {
            }, {});
          }, (errMsg, errList) => {
            console.log('checkFileStandard', errMsg);
            uploadCallBack({code: 500, data: {file,}, msg: errMsg,});
          });
        } else {
          this.upload(file, uploadCallBack, (res) => {
            if (isSingleFile) {
              console.log('progress', res);
              progress ? progress() : '';
            }
          }, {});
        }
      });
    } else {
      if (fail) {
        fail();
      }
      msgUploadErr('至少选择一个文件上传', fail);
    }
  }

  /**
   * 单个上传
   * @param file
   * @param callBack
   * @param progress
   * @param transData
   */
  upload(file, callBack, progress, transData) {
    if (!this.jiuLawUpload) {
      this.jiuLawUpload = new JiuLawUpload({
        baseUrl: `${api.BASE_SERVER}`,
        preUrl_: '/api/v1/file/generatePresignedInfo',
        verifyFileUrl: '/api/v1/file/verifyFile',
        classType:'brtTest',
      });
    }
    this.jiuLawUpload.upload(
      this.jiuLawUpload.createUploadParams(
        'brtTest',
        file,
        () => {
        },
        transData,
        '',
      ),
      {},
      (res) => {
        callBack ? callBack(res) : '';
      },
      (data) => {
        progress ? progress(data.rate) : '';
      },
    );
  }
}

export default MaterialUpload;


const msgErrorBack = (msg, error) => {
  if (error) {
    error(msg);
  }
};

const msgUploadErr = (msg, data = {}, error) => {
  if (error) {
    error({
      msg: msg || '上传发生错误',
      code: 500,
      data,
    });
  }
};


const checkFileEntryStandard = (fileEntry, success, fail, isZip, maxSize = MAX_SIZE) => {
  const errList = [];
  if (!fileEntry) {
    return;
  }
  const size = fileEntry.size;
  if (size <= 0) {
    errList.push('不得为0KB');
  }
  if (size > maxSize * 1024 * 1024) {
    const errTip = maxSize > 1024 ? `大小超过${maxSize / 1024}GB` : `大小超过${maxSize}MB`;
    errList.push(errTip);
  }

  // 检查特殊字符
  const name = fileEntry.name;
  if (!validConst.legalStrIncludeSpace(name)) {
    // console.log('name', name)
    errList.push('文件名称格式不对');
  }

  // 检查文件类型
  const index = name.lastIndexOf('.');
  const subfix = name.substr(index + 1).toLowerCase();
  if (isZip) {
    if ('.zip'.indexOf(subfix) == -1) {
      errList.push('文件格式不符合zip');
    }
  } else if ('.word,.doc,.docx,.pdf,.jpg,.jpeg,.bmp,.png,.gif,.tif,.tiff,image/*'.indexOf(subfix) == -1) {
    errList.push('文件类型错误');
  }


  if (errList.length > 0) {
    let errMsg = '';
    errList.forEach(msg => {
      errMsg += `${msg}、`;
    });
    errMsg = errMsg.substring(0, errMsg.length - 1);
    if (fail) {
      fail(errMsg, errList);
    }
  } else if (success) {
    success(fileEntry);
  }
};

const readDirEntries = (dirData, success, fail) => {
  const dirReader = dirData.createReader();
  if (dirReader) {
    dirReader.readEntries(fileEntryList => {
      if (fileEntryList && fileEntryList.length > 0) {
        success ? success(fileEntryList) : '';
      } else {
        fail ? fail() : '';
      }
    });
  } else {
    fail ? fail() : '';
  }
};

const readFile = (fileEntry, success, err) => {
  if (fileEntry) {
    fileEntry.file((file) => {
      // console.log('readFile', file)
      if (file) {
        if (success) {
          success(file);
        }
      } else if (err) {
        err();
      }
    }, errInfo => {
      if (err) {
        err();
      }
    });
  } else if (err) {
    err();
  }
};


